import { Injectable, inject } from '@angular/core';

import { ConfigProviderService } from '../config-provider/config-provider.service';

@Injectable({
    providedIn: 'root',
})
export class UtilityService {
    private readonly configProviderService = inject(ConfigProviderService);
    constructor() {}

    getPositionXY(e: any) {
        const res = { x: 0, y: 0 };
        if (e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchcancel') {
            const touch = e.touches[0] || e.changedTouches[0];
            res.x = touch.pageX;
            res.y = touch.pageY;
        } else if (
            e.type === 'mousedown' ||
            e.type === 'mouseup' ||
            e.type === 'mousemove' ||
            e.type === 'mouseover' ||
            e.type === 'mouseout' ||
            e.type === 'mouseenter' ||
            e.type === 'mouseleave'
        ) {
            res.x = e.pageX;
            res.y = e.pageY;
        }
        return res;
    }

    deepMergeObjects(mergeAccumulator: any, ...mergees: any[]) {
        if (mergeAccumulator == null) {
            mergeAccumulator = {};
        }

        const accumulatedMerge = Object(mergeAccumulator);

        //iterative vs recursive
        for (let argumentIndex = 0; argumentIndex < mergees.length; argumentIndex++) {
            const nextMergee = mergees[argumentIndex];

            if (nextMergee) {
                // Skip over if undefined or null
                for (const nextKeyToBeMerged in nextMergee) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextMergee, nextKeyToBeMerged)) {
                        if (
                            typeof accumulatedMerge[nextKeyToBeMerged] === 'object' &&
                            accumulatedMerge[nextKeyToBeMerged] &&
                            typeof nextMergee[nextKeyToBeMerged] === 'object' &&
                            nextMergee[nextKeyToBeMerged]
                        ) {
                            this.deepMergeObjects(accumulatedMerge[nextKeyToBeMerged]);
                        } else {
                            accumulatedMerge[nextKeyToBeMerged] = nextMergee[nextKeyToBeMerged];
                        }
                    }
                }
            }
        }
        return accumulatedMerge;
    }

    getDaysInMonth(year: number, month: number): number {
        return new Date(year, month, 0).getDate();
    }

    getLastMonthArcadeExpiry(): string {
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const coinExpiryDay = this.configProviderService.providePromoCoinEconomyConfig()?.coinExpiryDay - 1;
        const currentDay = new Date().getDate();
        if (currentDay <= coinExpiryDay) {
            return monthNames[new Date().getMonth() - 1];
        } else {
            return monthNames[new Date().getMonth()];
        }
    }

    /**Duplicate function present in casino manager file as well */
    getProductForGivenLobbyType(lobbyType: string): string {
        const lmtDataClientConfig: any = this.configProviderService.provideLmtConfig();
        const lobbyTypeMap: any = lmtDataClientConfig.lobbyTypeMap;
        for (let i = 0; i < lobbyTypeMap.length; i++) {
            if (lobbyTypeMap[i].lobbyType == lobbyType) {
                if (lobbyTypeMap[i].product) return lobbyTypeMap[i]?.product?.toLowerCase();
            }
        }
        return '';
    }

    getLanguageContentMap(languageArray: any): Map<string, string> {
        const languageMap: Map<string, string> = new Map<string, string>();
        if (languageArray && languageArray.length > 0) {
            for (let i = 0; i < languageArray.length; i++) {
                const langItem: string = languageArray[i];
                if (langItem.indexOf(':') > -1) {
                    const langResolve: any = langItem.split(':');
                    languageMap.set(langResolve[0], langResolve[1]);
                }
            }
        }
        return languageMap;
    }
}
